import React from 'react';
import { Box, CircularProgress, Typography, Autocomplete, TextField } from '@mui/material';

const TeacherSelector = ({
    teachers,
    selectedTeacher,
    loading,
    onTeacherChange
}) => {
    if (loading) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <CircularProgress size={20} sx={{ mr: 2 }} />
                <Typography>Caricamento insegnanti...</Typography>
            </Box>
        );
    }

    return (
        <Autocomplete
            fullWidth
            sx={{ mb: 3 }}
            options={teachers}
            getOptionLabel={(option) => `${option.CognomeMT || ''} ${option.NomeMT || ''} (${option.user_email || ''})`.trim()}
            value={teachers.find(t => t.user_id === selectedTeacher) || null}
            onChange={(event, newValue) => {
                onTeacherChange(newValue ? newValue.user_id : '');
            }}
            renderInput={(params) => <TextField {...params} label="Seleziona Insegnante" variant="outlined" />}
        />
    );
};

export default TeacherSelector;
